// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import ProductPreviousPurchase from "@keller/App/Components/Product/ProductPreviousPurchase";
import React, { FC } from "react";

interface OwnProps {
    extendedStyles?: TypographyPresentationProps;
}

type Props = OwnProps & HasProduct;

const ProductContextPreviousPurchase: FC<Props> = ({ product, extendedStyles }) => {
    return <ProductPreviousPurchase product={product} extendedStyles={extendedStyles} />;
};

export default withProduct(ProductContextPreviousPurchase);
